// Shared helpers for the three /v2/sequences ag-Grid screens (index, advanced
// search, limited preview, and the *_search result grids). They used to each
// build their own cell markup; the index grid interpolated raw values straight
// into href="" (so a value containing &, # or a quote produced a broken link)
// while the search grid escaped properly. One copy, escaped everywhere.

export function escapeHtml(value) {
  if (value === null || value === undefined) return '';

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// A cell linking to the database filtered to this exact value in `field`.
export function sequenceSearchLink(params, field) {
  const value = params.value;
  if (value === null || value === undefined || value === '') return '';

  const href = '/v2/sequences?search_text=' + encodeURIComponent(value) +
    '&match_location=exact_location&search_columns%5B%5D=' + encodeURIComponent(field);

  return `<a class="ag-link content" href="${escapeHtml(href)}">${escapeHtml(value)}</a>`;
}

export function plainText(params) {
  return `<span class="sequence-search-cell-text">${escapeHtml(params.value)}</span>`;
}

export function urlRenderer(params) {
  const value = params.value;
  if (value === null || value === undefined || value === '') return '';

  const escaped = escapeHtml(value);
  return `<a class="ag-link content" href="${escaped}" target="_blank" rel="noopener noreferrer">${escaped}</a>`;
}

// The Actions column: View always, Edit only for rows the server marked
// `editable` (ApplicationHelper#can_edit_sequence?). The old grid built an Edit
// and a Delete link and then returned only View, so the database offered no way
// into the editor at all.
export function actionsColumn(overrides = {}) {
  return Object.assign({
    headerName: 'Actions',
    field: 'id',
    width: 128,
    minWidth: 128,
    maxWidth: 128,
    pinned: 'left',
    lockPinned: true,
    sortable: false,
    filter: false,
    resizable: false,
    cellRenderer: function (params) {
      const id = encodeURIComponent(params.value);
      // Open the sequence in a NEW tab so a researcher browsing filtered results
      // doesn't lose their place (mirrors urlRenderer above). See Asana 1217511596196443.
      const view = `<a href="/v2/sequences/${id}" class="ag-link" target="_blank" rel="noopener noreferrer">View</a>`;
      if (!params.data || !params.data.editable) return view;

      return `${view}<span class="ag-action-sep" aria-hidden="true">·</span><a href="/v2/sequences/${id}/edit" class="ag-link">Edit</a>`;
    }
  }, overrides);
}

// ag-Grid needs an explicit pixel height, so a 1-row result used to sit in the
// same 480px+ box as a 2000-row one and left most of the card empty. Size the
// container to the rows it actually has, clamped between `min` and `max` (and
// by the viewport, so a full page still scrolls the grid rather than the page).
export function fitGridHeight(element, rowCount, options = {}) {
  if (!element) return;

  const headerHeight = options.headerHeight || 49;
  const rowHeight = options.rowHeight || 44;
  const min = options.min || 180;
  const max = Math.min(options.max || 620, Math.round(window.innerHeight * 0.76));
  const wanted = headerHeight + Math.max(rowCount, 1) * rowHeight + 2;

  element.style.height = Math.max(min, Math.min(max, wanted)) + 'px';
}
